<div class="page-container">
  <!-- Page Header -->
  <intelishs-page-header title="Empleados" subtitle="Gestion y administracion de personal" />

  <!-- Stats cards -->
  <div class="stats-row">
    <intelishs-stat-chip
      color="dark"
      label="Total"
      [value]="totalEmpleados()"
      [active]="!filtroActivo"
      (select)="filtroActivo = ''; buscar()"
    />
    <intelishs-stat-chip
      color="green"
      label="Activos"
      [value]="totalActivos()"
      [active]="filtroActivo === 'true'"
      (select)="filtroActivo = 'true'; buscar()"
    />
    <intelishs-stat-chip
      color="red"
      label="Inactivos"
      [value]="totalInactivos()"
      [active]="filtroActivo === 'false'"
      (select)="filtroActivo = 'false'; buscar()"
    />
  </div>

  <!-- Table -->
  <intelishs-data-table
    [data]="empleadosFiltrados()"
    [columns]="columns"
    [loading]="loading()"
    [pageSize]="15"
    [pageSizeOptions]="[10, 15, 25, 50]"
    searchPlaceholder="Buscar por nombre, ID, RFC, CURP, puesto, área o dirección..."
    [extraFilterKeys]="extraFilterKeys"
    [exportColumns]="exportColumns"
    [showAddButton]="true"
    (add)="nuevoEmpleado()"
    [showRefreshButton]="true"
    (refresh)="cargarEmpleados(true)"
    [showExportButton]="true"
    exportFilename="Empleados"
  >
    <!-- Empleado: nombre arriba, "ID · puesto" como contexto -->
    <ng-template intelishsCellTemplate="nombreCompleto" let-row>
      <intelishs-cell-stack
        [main]="row.nombreCompleto"
        [meta]="row.idInterno + (row.puesto ? ' · ' + row.puesto : '')"
      />
    </ng-template>

    <!-- Área arriba, dirección como contexto (se trunca con tooltip) -->
    <ng-template intelishsCellTemplate="area" let-row>
      <intelishs-cell-stack [main]="row.area || '—'" [meta]="row.direccion || ''" />
    </ng-template>

    <ng-template intelishsCellTemplate="acciones" let-row>
      <intelishs-table-actions
        [row]="row"
        [actions]="getActionsForRow(row)"
        (action)="onAction({ action: $event, row })"
      />
    </ng-template>
  </intelishs-data-table>

  <!-- Modal: cambio de área (DELETE+INSERT en relempleadodireccionarea) -->
  <app-cambiar-area-modal
    [(visible)]="cambiarAreaVisible"
    [empleado]="empleadoParaCambio()"
    (guardado)="onAreaCambiada()"
  />

  <!-- Modal: documentos del empleado (visual / sin backend hoy). Los archivos
       se manejan en memoria local del modal; la persistencia al FileManager
       API se conecta en otro pase cuando el catálogo del DBA esté listo. -->
  <app-documentos-modal [(visible)]="documentosVisible" [empleado]="empleadoParaDocs()" />
</div>
